import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Alert } from "../alert/alert";
import { User } from "../user/user";
import { UserService } from "../user/user.service";

@Component({
  selector: 'app-create-user-modal',
  templateUrl: './create-user-modal.component.html',
  styleUrls: ['./create-user-modal.component.css'],
  animations: [
    trigger('modalState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '1',
        display: 'flex'
      })),
      transition('hide => show, show => hide', animate('200ms ease-in'))
    ]),
    trigger('modalDialogState', [
      state('hide', style({
        opacity: '0',
        display: 'none'
      })),
      state('show', style({
        opacity: '0.8',
        display: 'flex'
      })),
      transition('hide => show, show => hide', animate('200ms ease-in'))
    ])
  ]
})
export class CreateUserModalComponent implements OnInit {

  public alert:Alert = new Alert('hide', '', '');
  public user:User = new User('', '');

  constructor(private userService:UserService) {
  }

  ngOnInit() {
  }

  @Input() modalState:string;

  @Output() modalStateChange = new EventEmitter();
  @Output() reloadUserlist = new EventEmitter();
  @Output() showAlert = new EventEmitter();

  public close():void {
    this.modalStateChange.emit('hide');
  }

  public createUser(user):void {
    this.userService.createUser(user)
      .subscribe(suc => {
        this.close();
        this.reloadUserlist.emit();
        this.showAlert.emit(new Alert('show', 'alert-success', 'Der Nutzer wurde erfolgreich angelegt'));
      }, err => {
        this.alert.update('show', 'alert-danger', 'Benutzername bereits vorhanden oder das Passwort genügt nicht den Anforderungen');
        setTimeout(() => this.alert.state = 'hide', 4000);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/create-user-modal/create-user-modal.component.ts